import React from 'react';
import PropTypes from 'prop-types';

const ErrorText = ({ children }) => (
  <p className="like-small text-red m-t-1 m-b-0">{children}</p>
);

ErrorText.propTypes = {
  children: PropTypes.string,
};

export default ErrorText;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/ErrorText.js